import { render, staticRenderFns } from "./ChickIcon.vue?vue&type=template&id=40e46027&scoped=true"
import script from "./ChickIcon.vue?vue&type=script&lang=js"
export * from "./ChickIcon.vue?vue&type=script&lang=js"
import style0 from "./ChickIcon.vue?vue&type=style&index=0&id=40e46027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e46027",
  null
  
)

export default component.exports